import React, { useEffect, useState } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AdminProducts from './AdminProducts';
import AdminCategories from './AdminCategories';
import AdminOrders from './AdminOrders';
import AdminSettings from './AdminSettings';
import AdminStats from './AdminStats';
import AdminContactMessages from './AdminContactMessages';
import StockAlertsModal from '../../components/StockAlertsModal';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showStockAlerts, setShowStockAlerts] = useState(false);
  const [hasShownAlerts, setHasShownAlerts] = useState(false);

  useEffect(() => {
    if (!user || !isAdmin()) {
      navigate('/hair-wp/login');
    } else if (user && !hasShownAlerts) {
      // Show stock alerts when admin first logs in
      setShowStockAlerts(true);
      setHasShownAlerts(true);
    }
  }, [user, isAdmin, navigate, hasShownAlerts]);

  if (!user || !isAdmin()) {
    return null;
  }

  return (
    <div className="admin-dashboard">
      {/* Floating menu button for mobile - always visible */}
      <button 
        className={`mobile-menu-toggle ${menuOpen ? 'active' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle admin menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      
      {/* Overlay when menu is open on mobile */}
      {menuOpen && (
        <div 
          className="admin-overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
      
      <div className={`admin-sidebar ${menuOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h2>Admin Panel</h2>
          <button 
            className="menu-toggle-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Close menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <nav className={`admin-nav ${menuOpen ? 'nav-open' : ''}`}>
          <Link to="/hair-wp" onClick={() => setMenuOpen(false)}>Dashboard</Link>
          <Link to="/hair-wp/products" onClick={() => setMenuOpen(false)}>Products</Link>
          <Link to="/hair-wp/categories" onClick={() => setMenuOpen(false)}>Categories</Link>
          <Link to="/hair-wp/orders" onClick={() => setMenuOpen(false)}>Orders</Link>
          <Link to="/hair-wp/contact-messages" onClick={() => setMenuOpen(false)}>Contact Messages</Link>
          <Link to="/hair-wp/settings" onClick={() => setMenuOpen(false)}>Settings</Link>
          <button onClick={logout} className="logout-btn">Logout</button>
        </nav>
      </div>
      <div className="admin-content">
        <Routes>
          <Route path="/" element={<AdminStats />} />
          <Route path="/products/*" element={<AdminProducts />} />
          <Route path="/categories/*" element={<AdminCategories />} />
          <Route path="/orders/*" element={<AdminOrders />} />
          <Route path="/contact-messages" element={<AdminContactMessages />} />
          <Route path="/settings" element={<AdminSettings />} />
        </Routes>
      </div>

      {showStockAlerts && (
        <StockAlertsModal 
          onClose={() => setShowStockAlerts(false)}
          onReplenish={() => {
            // Refresh products if on products page
            if (window.location.pathname.includes('/products')) {
              window.location.reload();
            }
          }}
        />
      )}
    </div>
  );
};

export default AdminDashboard;

